import React from "react";
import { Route } from "react-router-dom";
import MainPage from "./MainPage";

//export const MainPageRoute = <Route path='/' element={<MainPage />} />
export function mainPageNavigationUrl() {
    return `/`;
}
